import { FC, useEffect, useMemo, useState } from 'react';
import { Checkbox, Button, Tooltip } from 'antd';
import { ArrowUpOutlined } from '@ant-design/icons';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';
import styles from '../index.module.less';
import IconFont from '@/common/components/IconFont';
import PickFolderModal from 'src/views/lcn/pages/sitemap/components/CollectDrawer/PickFolderModal';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

/**
 * @Description 底部区域
 */
const Footer: FC<{
  listData, // 列表数据(注意和虚拟列表的数据并不真正相同，虚拟列表额外插入了一些字段，这里只用到id，所以没问题)
  showBack, // 是否显示返回顶部的按钮
  isBatchCollect, // 是否是批量收藏状态
  batchCollectIds, // 批量收藏的开店区域ids
  setBatchCollectIds,
  backTop, // 返回顶部
  handleQuitBatch, // 退出全选
}> = ({
  listData, // 列表数据(注意和虚拟列表的数据并不真正相同，虚拟列表额外插入了一些字段，这里只用到id，所以没问题)
  showBack, // 是否显示返回顶部的按钮
  isBatchCollect, // 是否是批量收藏状态
  batchCollectIds, // 批量收藏的开店区域ids
  setBatchCollectIds,
  backTop, // 返回顶部
  handleQuitBatch, // 退出全选
}) => {
  const [openCollectModal, setOpenCollectModal] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  // 虚拟列表中所有数据的id组成的ids
  const listIds = useMemo(() => {
    return listData.map((listItem: any) => listItem.id);
  }, [listData]);

  useEffect(() => {
    const checkedLen = batchCollectIds?.length;
    // 是否是indeterminate状态
    setIndeterminate(checkedLen > 0 && checkedLen < listIds?.length);
    setCheckAll(checkedLen === listIds.length); // 是否全选
  }, [batchCollectIds, listIds]);

  const methods = useMethods({
    onChange: (e: any) => { // 全选按钮的change事件
      const isChecked = e.target.checked; // 是否选中
      if (isChecked && listIds.length > 500) { // 如果全选选中时而且列表数据超过了500条
        setIndeterminate(true);
        setCheckAll(false);
        const len = batchCollectIds.length;
        // 如果此时已经有选中的ids，从索引0开始往数组中push未选中的，直到选够500条
        if (len > 0) {
          const differenceValue = 500 - len;
          const waitIds: number[] = [];
          for (let i = 0; i < listIds.length; i++) {
            const curId = listIds[i]; // 当前id
            // 已经够500条了
            if (waitIds.length >= differenceValue) break;
            // 如果已经选中过了，就跳出本次循环
            if (batchCollectIds.includes(curId)) continue;
            // 加入待插入数组
            waitIds.push(curId);
          }
          const ids500 = [...batchCollectIds, ...waitIds];
          setBatchCollectIds(ids500);
          V2Message.warning('最多勾选500个开店区域');
          return;
        }
        const top500 = listIds.filter((id: number, index: number) => index < 500);
        setBatchCollectIds(top500);
        V2Message.warning('最多勾选500个开店区域');
        return;
      }
      setBatchCollectIds(isChecked ? listIds : []);
      setIndeterminate(false);
      setCheckAll(isChecked);
    },
    addToCollection: async () => { // 加入收藏夹
      const len = batchCollectIds.length;
      if (len && len <= 500) {
        // const params = await handleCollectOfFetch();
        setOpenCollectModal(true);
      }
    }
  });

  return (
    <div className={cs(styles.footerCon, isBatchCollect ? styles.hasBottomCon : '')}>
      {/* 返回顶部的icon */}
      {
        showBack ? <div
          className={cs(styles.backCon, isBatchCollect ? styles.isBitHigh : '')}
          onClick={backTop}
        >
          <ArrowUpOutlined className='fs-16'/>
        </div> : <></>
      }
      {/* 批量收藏状态 */}
      {
        isBatchCollect ? <div className={styles.flexCon}>
          <Checkbox
            checked={checkAll}
            indeterminate={indeterminate}
            onChange={methods.onChange}
            className='c-222 fs-12'
          >
            {
              batchCollectIds?.length > 0 ? `已选${batchCollectIds?.length}` : '全选'
            }
          </Checkbox>
          <div className='rt' style={{ flex: 1 }}>
            <Button
              type='primary'
              disabled={!batchCollectIds.length}
              style={{
                paddingLeft: '24px',
                paddingRight: '24px',
              }}
              onClick={methods.addToCollection}
            >
              加入收藏夹
            </Button>
          </div>
          <Tooltip title='退出批量收藏'>
            <div
              className={cs('ml-8 pointer', styles.iconCon)}
              onClick={handleQuitBatch}
            >
              <IconFont iconHref='iconupload' />
            </div>
          </Tooltip>
        </div> : <></>
      }

      {/* 批量收藏弹窗 */}
      <PickFolderModal
        open={openCollectModal}
        selectedIds={batchCollectIds}
        setOpen={setOpenCollectModal}
        callFn={handleQuitBatch}
      />
    </div>
  );
};

export default Footer;
